import { doLogout } from 'actions/authAction'
import { BASE_URL } from '../actions/constant';
export const CONTAINER_SIZE_GET_LOADING = 'CONTAINER_SIZE_GET_LOADING';
export const CONTAINER_SIZE_GET_ERROR = 'CONTAINER_SIZE_GET_ERROR';
export const CONTAINER_SIZE_GET = 'CONTAINER_SIZE_GET';

export const CONTAINER_SIZE_ADD_LOADING = 'CONTAINER_SIZE_ADD_LOADING';
export const CONTAINER_SIZE_ADD_ERROR = 'CONTAINER_SIZE_ADD_ERROR';
export const CONTAINER_SIZE_ADD = 'CONTAINER_SIZE_ADD';

export const CONTAINER_SIZE_UPDATE_LOADING = 'CONTAINER_SIZE_UPDATE_LOADING';
export const CONTAINER_SIZE_UPDATE_ERROR = 'CONTAINER_SIZE_UPDATE_ERROR';
export const CONTAINER_SIZE_UPDATE = 'CONTAINER_SIZE_UPDATE';

export const CONTAINER_SIZE_DELETE_LOADING = 'CONTAINER_SIZE_DELETE_LOADING';
export const CONTAINER_SIZE_DELETE_ERROR = 'CONTAINER_SIZE_DELETE_ERROR';
export const CONTAINER_SIZE_DELETE = 'CONTAINER_SIZE_DELETE';


const sizeGetError = (bool) => {
  return {
    type: CONTAINER_SIZE_GET_ERROR,
    sizeGetError: bool
  }
}

const sizeGetLoading = (bool) => {
    return {
      type: CONTAINER_SIZE_GET_LOADING,
      sizeGetLoading: bool
    }
}

const sizeGetSuccess = (bool, sizes) => {
  return {
    type: CONTAINER_SIZE_GET,
    sizeGetSuccess: bool,
    sizes
  }
}

const sizeAddError = (bool) => {
  return {
    type: CONTAINER_SIZE_ADD_ERROR,
    sizeAddError: bool
  }
}

const sizeAddLoading = (bool) => {
    return {
      type: CONTAINER_SIZE_ADD_LOADING,
      sizeAddLoading: bool
    }
}

const sizeAddSuccess = (bool, size) => {
  return {
    type: CONTAINER_SIZE_ADD,
    sizeAddSuccess: bool,
    size
  }
}

const sizeUpdateError = (bool) => {
  return {
    type: CONTAINER_SIZE_UPDATE_ERROR,
    sizeUpdateError: bool
  }
}

const sizeUpdateLoading = (bool) => {
    return {
      type: CONTAINER_SIZE_UPDATE_LOADING,
      sizeUpdateLoading: bool
    }
}

const sizeUpdateSuccess = (bool, size) => {
  return {
    type: CONTAINER_SIZE_UPDATE,
    sizeUpdateSuccess: bool,
    size
  }
}

const sizeDeleteError = (bool) => {
  return {
    type: CONTAINER_SIZE_DELETE_ERROR,
    sizeDeleteError: bool
  }
}

const sizeDeleteLoading = (bool) => {
    return {
      type: CONTAINER_SIZE_DELETE_LOADING,
      sizeDeleteLoading: bool
    }
}

const sizeDeleteSuccess = (bool, size) => {
  return {
    type: CONTAINER_SIZE_DELETE,
    sizeDeleteSuccess: bool,
    size
  }
}

export function sizeFetchAll() {
  return (dispatch) => {
    dispatch(sizeGetSuccess(false, null))
    dispatch(sizeGetError(false))
    dispatch(sizeGetLoading(true))

    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if (token) {
      config = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + "size-container", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(sizeGetLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(sizeGetSuccess(true, data))
      })
      .catch((err) => {
        dispatch(sizeGetError(true))
      })
  }
}

export function sizeAdd(data) {
  return (dispatch) => {
    dispatch(sizeAddSuccess(false, null))
    dispatch(sizeAddError(false))
    dispatch(sizeAddLoading(true))

    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if (token) {
      config = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + "size-container", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(sizeAddLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(sizeAddSuccess(true, data))
        window.location.reload()
      })
      .catch((err) => {
        dispatch(sizeAddError(true))
      })
  }
}

export function sizeUpdate(data) {
  return (dispatch) => {
    dispatch(sizeUpdateSuccess(false, null))
    dispatch(sizeUpdateError(false))
    dispatch(sizeUpdateLoading(true))

    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if (token) {
      config = {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + "size-container", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(sizeUpdateLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(sizeUpdateSuccess(true, data))
        window.location.reload()
      })
      .catch((err) => {
        dispatch(sizeUpdateError(true))
      })
  }
}

export function sizeDelete(data) {
  return (dispatch) => {
    dispatch(sizeDeleteSuccess(false, null))
    dispatch(sizeDeleteError(false))
    dispatch(sizeDeleteLoading(true))

    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if (token) {
      config = {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + "size-container", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(sizeDeleteLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(sizeDeleteSuccess(true, data))
        window.location.reload()
      })
      .catch((err) => {
        dispatch(sizeDeleteError(true))
      })
  }
}